import { CalendarCheckIcon, CheckCircleIcon, MinusCircleIcon, PaperPlaneTiltIcon, SparkleIcon } from '@phosphor-icons/react'

import { emotionTheme } from '@styles/theme'

import type { ReactNode } from 'react'
import type { WeekStatusCode } from './types'

interface WeekStatusStyleProps {
  icon: ReactNode
  color: string
  background: string
}

export const WEEK_STATUS_CONFIG: Record<WeekStatusCode, WeekStatusStyleProps> = {
  not_started: {
    icon: <MinusCircleIcon size={16} weight="bold" />,
    color: emotionTheme.colors.secondary,
    background: emotionTheme.colors.gray[300]
  },
  in_progress: {
    icon: <SparkleIcon size={16} weight="fill" />,
    color: emotionTheme.colors.yellow[500],
    background: emotionTheme.colors.yellow[100]
  },
  pending_approval: {
    icon: <PaperPlaneTiltIcon size={16} weight="fill" />,
    color: emotionTheme.colors.green.light,
    background: emotionTheme.colors.green[100]
  },
  completed: {
    icon: <CheckCircleIcon size={16} weight="fill" />,
    color: emotionTheme.colors.green.color,
    background: emotionTheme.colors.green.background
  },
  auto_send: {
    icon: <CalendarCheckIcon size={16} weight="fill" />,
    color: emotionTheme.colors.teal.color,
    background: emotionTheme.colors.teal.background
  }
}
